export const SET_STAFF_DATA = 'staff/set-staff-data';
export const RESET_STAFF_DATA = 'staff/reset-staff-data';
export const SET_ACCOUNT_DATA = 'account/set-account-data';
export const RESET_ACCOUNT_DATA = 'account/reset-account-data';
export const SET_ROLE_NAME_DATA = 'account/set-role-name-data';
